
<template>
  <div class="container">
    <v-header></v-header>

    <div class="searchBody">
      <div class="psearch">
        <img src="../../assets/logo.png" class="logo" />
        <label>想象无界,创意无边</label>
        <input type="text" class="prosearch" />
        <input type="button" value="搜索" class="submitsearch" />
      </div>
    </div>

    <div class="nav">
      <div class="item-body">
        <ul>
          <li :class="licolors=='全部订单'?'colors':''">全部订单</li>
          <li :class="licolors=='待确认'?'colors':''">待确认</li>
          <li :class="licolors=='待发货'?'colors':''">待发货</li>
          <li :class="licolors=='待收货'?'colors':''">待收货</li>
        </ul>
      </div>
    </div>

    <div class="body-container">
      <div class="item-body" v-for="(item,itemIndex) in orderList" :key="itemIndex">
        <div class="item-header">
          <div class="item-header-left">
            <div class="item-number-title">订单编号：</div>
            <div class="item-number">{{item.order_no}}</div>
          </div>
          <div class="item-header-right">{{item.created_at}}</div>
        </div>
        <div class="item-line"></div>
        <div class="list-item" v-for="(order,index) in JSON.parse(item.products)" :key="index">
          <div class="order-left">
            <img class="order-img" :src="order.product_image" />

            <div class="order-info">
              <div class="info-title">{{order.product_title}}</div>
              <div
                class="info-size"
                v-for="(attr,index) in order.attrs"
                :key="index"
                v-show="attr.product_key !='生产类型'"
              >{{attr.product_key}}：{{attr.product_value}}</div>
            </div>
          </div>

          <div class="order-number">X {{order.count}}</div>
          <div class="order-type-item">
            <div class="order-type">打样</div>
            <div class="line"></div>
            <div class="order-type">大货</div>
            <div class="line"></div>
            <div class="order-type2">交易成功</div>
          </div>
          <div class="order-right">
            <a class="order-detail-title" @click="orderDetail(itemIndex)" href="#">订单详情</a>

            <div class="order-detail-title">申请售后</div>
            <div class="order-detail-title">取消订单</div>
          </div>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import header from "../header";
import footer from "../footer";

export default {
  name: "myOrder",
  props: ["proshows", "licolors"],
  watch: {
    licolors: function(a, b) {}
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  data() {
    return {
      orderList: []
    };
  },
  methods: {
    getOrderList() {
      this.$http.getMyOrder().then(res => {
        this.orderList = res.orders.map(order => ({
          ...order
        }));
        console.log(JSON.parse(this.orderList[0].products));
      });
    },
    orderDetail(index) {
      let detail = `detail${index}`;
      localStorage.setItem(detail, JSON.stringify(this.orderList[index]));
      this.$router.push({
        path: "orderDetails",
        query: {
          detail: detail
        }
      });
    }
  },
  filters: {},
  computed: {},
  created() {
    this.getOrderList();
  }
};
</script>

<style  lang='scss'  scoped>
.container {
  width: 100%;
}

.searchBody {
  width: 100%;
  height: 144px;
  background-color: #fff;
  .psearch {
    width: 1200px;
    height: 144px;
    background-color: #fff;
    line-height: 140px;
    margin: 0 auto;
    position: relative;
    .logo {
      position: absolute;
      top: 40px;
    }
    label {
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: 40px;
      left: 220px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
    }
    .prosearch {
      width: 400px;
      height: 48px;
      line-height: 48px;
      top: 40px;
      right: 80px;
      position: absolute;
      border: 0;
      border: 2px solid red;
      font-size: 20px;
    }
    .submitsearch {
      width: 80px;
      height: 52px;
      background-color: red;
      border-radius: 0;
      color: white;
      font-size: 15px;
      border: 0;
      top: 40px;
      right: 0px;
      position: absolute;
    }
  }
}

.nav {
  width: 100%;
  height: 56px;
  background-color: #fff;

  position: relative;
  .item-body {
    width: 1200px;
    margin: 0 auto;
    ul {
      list-style: none;
      position: absolute;
      bottom: 0;
      li.proshowstyle {
        float: left;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: rgba(239, 45, 35, 1);
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      li {
        float: left;
        cursor: pointer;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      li:hover {
        color: #e7001e;
      }
      .colors {
        color: #e7001e;
      }
    }
  }
}

.body-container {
  width: 100%;
  height: 100%;
  .item-body {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    flex-direction: column-reverse;
    .item-header {
      width: 1200px;
      height: 44px;
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      margin: 24px 0 0 0;
      .item-header-left {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        .item-number-title {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 20px;
          text-align: center;
          margin: 12px 0 0 24px;
        }
        .item-number {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 20px;
          margin: 12px 0 0 0;
        }
      }
      .item-header-right {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 12px 24px 0 0;
      }
    }
    .item-line {
      width: 1200px;
      height: 1px;
      background: rgba(232, 232, 232, 1);
    }
    .list-item {
      width: 1200px;
      height: 128px;
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      .order-left {
        max-width: 500px;
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        .order-img {
          width: 96px;
          height: 96px;
          background-color: #d1d1d1;
          margin: 16px 0 0 24px;
        }
        .order-info {
          max-width: 330px;
          height: 96px;
          flex-direction: column;
          justify-content: space-between;
          display: flex;
          margin: 16px 0 0 16px;
          .info-title {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
          }
          .info-size {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 20px;
          }
        }
      }

      .order-number {
        font-size: 14px;
        font-family: HelveticaNeue-Bold, HelveticaNeue;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        text-align: center;
        padding: 50px 0 0 0;
      }
      .order-type-item {
        height: 40px;
        border: 1px solid rgba(217, 217, 217, 1);
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        padding: 10px 16px 0 16px;
        margin: 40px 0 0 0;
        .item-type {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
          text-align: center;
        }
        .line {
          width: 1px;
          height: 10px;
          background: rgba(0, 0, 0, 0.25);
          margin: 4px 16px 0 16px;
        }
        .item-type2 {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
          text-align: center;
        }
      }
      .order-right {
        flex-direction: column-reverse;
        justify-content: space-between;
        height: 128px;
        margin: 28px 40px 0 0;
        .order-detail-title {
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
        }
      }
    }
  }
}

.shopType {
  width: 1200px;
  height: 80px;
  position: relative;
  background-color: #fff;
  margin: 25px auto;

  .typeTitle {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    padding: 16px 0 0 25px;
    position: absolute;
  }

  .line {
    width: 1px;
    height: 10px;
    background: rgba(232, 232, 232, 1);
    position: absolute;
    margin: 21px 0 0 108px;
  }
}
</style>
